/* OCC: explicit collection return state. No analytics. */
(() => {
 'use strict';
 const key='occ-results-return-v1';
 const collection=location.pathname.includes('/collections/') && !location.pathname.includes('/products/');
 const safe=url=>{try{const u=new URL(url,location.origin);return u.origin===location.origin && u.pathname.includes('/collections/') && !u.pathname.includes('/products/');}catch{return false;}};
 if(collection){
   document.addEventListener('click',e=>{if(e.target.closest('#product-grid a[href*="/products/"]')){try{sessionStorage.setItem(key,JSON.stringify({url:location.pathname+location.search,y:scrollY,time:Date.now()}));}catch{}}});
   try{const item=JSON.parse(sessionStorage.getItem(key));if(item?.restore && safe(item.url) && item.url===location.pathname+location.search && Date.now()-item.time<1800000){delete item.restore;sessionStorage.setItem(key,JSON.stringify(item));Promise.race([Promise.all([...document.images].map(i=>i.decode?.().catch(()=>{}))),new Promise(resolve=>setTimeout(resolve,800))]).then(()=>scrollTo(0,item.y));}}catch{}
 }
 if(location.pathname.includes('/products/')){
   try{const item=JSON.parse(sessionStorage.getItem(key));if(item && safe(item.url) && Date.now()-item.time<1800000){
     const link=document.createElement('a');link.className='occ-back-results';link.href=item.url;link.textContent='← Back to your filtered results';
     link.addEventListener('click',()=>{try{sessionStorage.setItem(key,JSON.stringify({...item,restore:true}));}catch{}});
     document.querySelector('main')?.prepend(link);
   }}catch{}
 }
})();
